import PropTypes from 'prop-types'
import { createContext, useContext, useState, useCallback, useEffect, useMemo } from 'react'
import styled from 'astroturf/react'
import { BareButton } from '@calendly/ui/components/bare-button'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue700))'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
import { HtmlParser } from '@calendly/html-parser'

import { useI18n } from 'locales'
import { formatMaskedPhoneNumber } from 'services/phone_number'

import { InstructionText } from './styles'
import _ResendButton from "resend_prompt-ResendButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/resend_prompt.js?styleId=ResendButton";
import _Prompt from "resend_prompt-Prompt.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/phone_verification/resend_prompt.js?styleId=Prompt";


const ResendButton = /*#__PURE__*/styled(BareButton, null, {
  displayName: "ResendButton",
  styles: _ResendButton
})

const Prompt = /*#__PURE__*/styled(InstructionText, null, {
  displayName: "Prompt",
  styles: _Prompt
})

const ResendPromptContext = createContext(null)

const ResendVerificationCode = ({ children }) => {
  const { handleResend, isResending } = useContext(ResendPromptContext)

  return (
    <ResendButton type="button" onClick={handleResend} disabled={isResending}>
      {children}
    </ResendButton>
  )
}

export const ResendPrompt = ({ phoneNumber, onResend, isResending }) => {
  const { i18n } = useI18n()
  const [hasResent, setHasResent] = useState(false)
  const maskedPhone = formatMaskedPhoneNumber(phoneNumber)

  useEffect(() => {
    setHasResent(false)
  }, [phoneNumber])

  const handleResend = useCallback(async () => {
    try {
      await onResend?.()
      setHasResent(true)
    } catch {
      // Leave the prompt unchanged if the resend fails.
    }
  }, [onResend])

  const contextValue = useMemo(
    () => ({ handleResend, isResending }),
    [handleResend, isResending],
  )

  const promptKey = hasResent
    ? 'booking.phone_verification.resend_code'
    : 'booking.phone_verification.code_sent_to'

  return (
    <ResendPromptContext.Provider value={contextValue}>
      <Prompt>
        {HtmlParser(i18n.t(promptKey, { masked_phone: maskedPhone }), {
          ResendVerificationCode,
        })}
      </Prompt>
    </ResendPromptContext.Provider>
  )
}

ResendPrompt.propTypes = {
  phoneNumber: PropTypes.string,
  onResend: PropTypes.func,
  isResending: PropTypes.bool,
}
